"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPencil', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M11.7071 1.29289C11.3166 0.902369 10.6834 0.902369 10.2929 1.29289L2.29292 9.29289C2.16476 9.42105 2.07384 9.58163 2.02988 9.75746L1.02988 13.7575C0.944685 14.0982 1.04453 14.4587 1.29291 14.7071C1.54129 14.9555 1.90178 15.0553 2.24256 14.9701L6.24256 13.9701C6.41839 13.9262 6.57897 13.8353 6.70713 13.7071L14.7071 5.70711C14.8947 5.51957 15 5.26522 15 5C15 4.73478 14.8947 4.48043 14.7071 4.29289L11.7071 1.29289ZM9.91429 4.49995L11 3.41421L12.5858 5L11.5 6.08578L9.91429 4.49995ZM8.50008 5.91416L3.90299 10.5112L3.37439 12.6256L5.48877 12.097L10.0858 7.49999L8.50008 5.91416Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M17.7071 5.29289L14.7071 2.29289C14.3166 1.90237 13.6834 1.90237 13.2929 2.29289L3.29291 12.2929C3.16476 12.4211 3.07384 12.5816 3.02988 12.7575L2.02988 16.7575C1.94469 17.0982 2.04453 17.4587 2.29291 17.7071C2.54129 17.9555 2.90178 18.0553 3.24256 17.9701L7.24256 16.9701C7.41839 16.9262 7.57897 16.8353 7.70713 16.7071L14.7071 9.70711L17.7071 6.70711C18.0977 6.31658 18.0977 5.68342 17.7071 5.29289ZM14 7.58579L15.5858 6L14 4.41421L12.4142 6L14 7.58579ZM11 7.41422L4.90298 13.5112L4.37439 15.6256L6.48877 15.097L12.5858 9L11 7.41422Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M21.2071 6.99992L17.2071 2.99993C16.8166 2.6094 16.1834 2.6094 15.7929 2.99993L3.79291 14.9999C3.65331 15.1395 3.55815 15.3173 3.51944 15.5109L2.51944 20.5109C2.45386 20.8388 2.55649 21.1777 2.79291 21.4141C3.02933 21.6506 3.36827 21.7532 3.69613 21.6876L8.69613 20.6876C8.88972 20.6489 9.06752 20.5537 9.20712 20.4141L21.2071 8.41414C21.3947 8.2266 21.5 7.97225 21.5 7.70703C21.5 7.44181 21.3947 7.18746 21.2071 6.99992ZM14.4142 7.20703L16.5 5.12124L19.0858 7.70703L17 9.79282L14.4142 7.20703ZM13 8.62125L15.5858 11.207L8.007 18.7858L4.77477 19.4323L5.42122 16.2L13 8.62125Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M23.5607 3.43934C22.9749 2.85355 22.0252 2.85355 21.4394 3.43934L5.43937 19.4393C5.24058 19.6381 5.10166 19.8888 5.03844 20.1627L3.53844 26.6627C3.42215 27.1667 3.57366 27.695 3.93937 28.0607C4.30507 28.4264 4.83338 28.5779 5.33732 28.4616L11.8373 26.9616C12.1112 26.8984 12.3619 26.7594 12.5607 26.5607L23.0563 16.0651C23.0578 16.0636 23.0592 16.0621 23.0607 16.0607C23.0622 16.0592 23.0636 16.0577 23.0651 16.0563L28.5607 10.5607C29.1465 9.97487 29.1465 9.02513 28.5607 8.43934L23.5607 3.43934ZM19.1213 10L22.5 6.62132L25.3787 9.5L22 12.8787L19.1213 10ZM17 12.1213L7.86488 21.2565L7.00128 24.9987L10.7436 24.1351L19.8787 15L17 12.1213Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;